import React from 'react'
import { Link } from 'react-router-dom'
import "./nav.scss"

const Navbar = () => {
  return (
    <div className='navbar'>
      <div><Link to='/'>Home</Link></div>
      <div><Link to='/test'>Range</Link></div>
    </div>
  )
}

export default Navbar
